import styles from "./PaymentMethod.module.scss";
import emptyIcon from "../../../assets/images/icons/payment-empty.svg";
import { useTranslation } from "react-i18next";
import CustomButton from "../../ui/CustomButton/CustomButton";
import plusIcon from "../../../assets/images/icons/plus.svg";
import { useState } from "react";
import AddPaymentMethodPopup from "../AddNewPaymentMethodPopup/AddNewPaymentMethodPopup";
import { useGetStripePaymentMethodsQuery } from "../../../api/queries";

const PaymentMethodEmpty = () => {
  const { t } = useTranslation();
  const { refetch } = useGetStripePaymentMethodsQuery();

  const [showAddNewPopup, setShowAddNewPopup] = useState(false);

  const clickOnAddNewCard = () => {
    setShowAddNewPopup(true);
  };

  return (
    <>
      <div className={styles.container}>
        <img className={styles.image} src={emptyIcon} alt={"empty"} />
        <h3 className={styles.title}>{t("YouHaveNoCardsAvailable")}</h3>
        <div className={styles.btnWrapper}>
          <CustomButton
            text={t("AddNewCard")}
            type={"button"}
            typeStyle={"fill"}
            functionOnClick={clickOnAddNewCard}
            icon={plusIcon}
            altIcon={"plus"}
          />
        </div>
      </div>
      {showAddNewPopup && (
        <AddPaymentMethodPopup refetch={refetch} onClose={() => setShowAddNewPopup(false)} />
      )}
    </>
  );
};

export default PaymentMethodEmpty;
